import { z } from "zod";

import { optionalUrlField, requiredString } from "./fields";

export const personalLinkRowSchema = z
	.object({
		type: requiredString("Select a link type"),
		value: optionalUrlField(),
	})
	.superRefine((row, context) => {
		if (row.value === "") {
			context.addIssue({ code: "custom", path: ["value"], message: "Enter a valid URL (https://...)" });
		}
	});
